import { HealthCheckResponse } from '~/models'
import axiosClient from './axiosClient'

export const healthCheckApis = {
  getHealthCheck: () => axiosClient.get("/health") as unknown as HealthCheckResponse,
}
